module.exports = __webpack_public_path__ + "media/packs/site/assets/images/illust_stop-caea45d16bf3f2ddf7ab1e27502d08b9.png";